import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-md font-bold" }
const _hoisted_5 = { class: "text-xs text-gray-500" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "space-y-2 py-4 px-6" }
const _hoisted_8 = { class: "flex mb-3 space-x-1 items-center lg:text-2xl" }
const _hoisted_9 = { class: "font-extrabold" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_11 = { class: "text-sm text-gray-500" }
const _hoisted_12 = { class: "font-bold text-gray-800" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "flex items-center justify-start space-x-3"
}
const _hoisted_15 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_16 = { class: "font-bold text-gray-800" }
const _hoisted_17 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_18 = { class: "font-bold text-gray-800" }
const _hoisted_19 = {
  key: 2,
  class: "flex items-center justify-between"
}
const _hoisted_20 = { class: "text-sm text-gray-500" }
const _hoisted_21 = { class: "font-bold text-gray-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, null, -1)
const _hoisted_23 = {
  key: 3,
  class: "flex items-center justify-between"
}
const _hoisted_24 = { class: "text-sm text-gray-500" }
const _hoisted_25 = { class: "font-bold text-gray-800" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, null, -1)
const _hoisted_27 = {
  key: 4,
  class: "flex items-center justify-between"
}
const _hoisted_28 = { class: "text-sm text-gray-500" }
const _hoisted_29 = { class: "font-bold text-gray-800" }
const _hoisted_30 = {
  key: 5,
  class: "flex items-center justify-between"
}
const _hoisted_31 = { class: "text-sm text-gray-500" }
const _hoisted_32 = { class: "font-bold text-gray-800" }
const _hoisted_33 = {
  key: 6,
  class: "flex items-center justify-between"
}
const _hoisted_34 = { class: "text-sm text-gray-500" }
const _hoisted_35 = { class: "font-bold text-gray-800" }
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_37 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_38 = {
  key: 1,
  class: "border-t mt-4 md:mt-0 p-4 px-6 flex justify-center"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Hide from borrower", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Show to borrower", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.distribution)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex items-center justify-between border-b p-4 px-6", { 'cursor-pointer': _ctx.showControls }]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showProfile(_ctx.distribution.originator.id)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.distribution.lender.logoUri)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.distribution.lender.logoUri,
                  class: "max-h-8 mr-2"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.distribution.lender.name), 1),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.quote.createdDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.moment(_ctx.quote.createdDate)), 1))
                  : _createCommentVNode("", true),
                _createTextVNode("by " + _toDisplayString(_ctx.distribution.originator.name), 1)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.quote.termYears ? `${_ctx.quote.termYears} years at` : '') + " " + _toDisplayString(_ctx.quote.rate.startRate) + "% " + _toDisplayString(_ctx.quote.rate.type), 1)
      ]),
      (_ctx.quote.loanAmount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, "$" + _toDisplayString(_ctx.convertToCurrency(_ctx.quote.loanAmount)), 1),
              _createTextVNode(" loan amount ")
            ]),
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.maxLTV || _ctx.quote.maxLTC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_ctx.quote.maxLTV)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.quote.maxLTV) + "%", 1),
                  _createTextVNode(" LTV ")
                ]))
              : _createCommentVNode("", true),
            (_ctx.quote.maxLTC)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.quote.maxLTC) + "%", 1),
                  _createTextVNode(" LTC ")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.amortization)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.quote.amortization) + " years", 1),
              _createTextVNode(" amortization ")
            ]),
            _hoisted_22
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.rate && _ctx.quote.rate.index && _ctx.quote.rate.index.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.quote.rate.index.description), 1),
              _createTextVNode(" indexed ")
            ]),
            _hoisted_26
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.interestOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.quote.interestOnly.period) + " " + _toDisplayString(_ctx.quote.interestOnly.details), 1),
              _createTextVNode(" interest-only ")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.dscr)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.quote.dscr), 1),
              _createTextVNode(" Minimum DSCR ")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.originationFee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.quote.originationFee) + "% ~ $" + _toDisplayString((_ctx.quote.originationFee / 100) * _ctx.quote.loanAmount), 1),
              _createTextVNode(" origination fee ")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.quote.rate?.type || _ctx.quote.recourse || _ctx.quote.prepaymentPenalty)
        ? (_openBlock(), _createElementBlock("div", {
            key: 7,
            class: _normalizeClass(["pt-2", { 'space-x-2 items-start flex flex-wrap': !_ctx.distribution, 'space-y-2': !!_ctx.distribution }])
          }, [
            (_ctx.quote.rate && _ctx.quote.rate.type)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["text-xs font-medium rounded-md px-2 py-1", {
              'text-green-700 bg-green-100': _ctx.quote.rate.type == 'Fixed',
              'text-yellow-700 bg-yellow-100': _ctx.quote.rate.type !== 'Fixed'
            }])
                }, _toDisplayString(_ctx.quote.rate.type == 'Fixed' ? 'Fixed at signing' : 'Not fixed at signing'), 3))
              : _createCommentVNode("", true),
            (_ctx.quote.recourse)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["text-xs font-medium rounded-md px-2 py-1", {
              'text-green-700 bg-green-100': _ctx.quote.recourse.type.id == 'Full',
              'text-yellow-700 bg-yellow-100': _ctx.quote.recourse.type.id !== 'Full'
            }])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.quote.recourse.type.description) + " Recourse ", 1),
                  (_ctx.quote.recourse.details)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, " - " + _toDisplayString(_ctx.quote.recourse.details), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.quote.prepaymentPenalty)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["text-xs font-medium rounded-md px-2 py-1", {
              'text-green-700 bg-green-100': !_ctx.quote.prepaymentPenalty.details,
              'text-yellow-700 bg-yellow-100': _ctx.quote.prepaymentPenalty.details
            }])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.quote.prepaymentPenalty.details ? 'Prepayment Penalties' : 'No prepayment penalty') + " ", 1),
                  (_ctx.quote.prepaymentPenalty.details)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, " - " + _toDisplayString(_ctx.quote.prepaymentPenalty.details), 1))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showControls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          (_ctx.quote.isVisibleToBorrower)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "flex items-center text-sky",
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.updateQuote(false)), ["prevent"]))
              }, [
                _createVNode(_component_EyeOffIcon, { class: "w-4 h-4 mr-1" }),
                _hoisted_39
              ]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "flex items-center text-sky",
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateQuote(true)), ["prevent"]))
              }, [
                _createVNode(_component_EyeIcon, { class: "w-4 h-4 mr-1" }),
                _hoisted_40
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}